import React from 'react'

const Graph = () => {
  return (
    <div>
        <iframe src="https://visualgo.net/en/graphds?slide=1" width="100%" height="920px" title="Graph"></iframe>
    </div>
  )
}

export default Graph